import { AdType } from '@/modules/adv/types'

import type { HbBidderConfig } from '../types'

const CID = '8CA53JDNP'

const createMediaNetConfig = (adUnitsMap: Partial<Record<AdType, string>>): HbBidderConfig => ({
    bidder: 'medianet',
    params: ({ type }) => {
        const crid = adUnitsMap[type]
        if (crid) {
            return {
                cid: CID,
                crid,
            }
        }
        return undefined
    },
})

const commonCRIDs = {
    leaderboard: '819185338',
    leaderboard_rest: '819185338',
    sidebar: '976222860',
    sidebar_bottom: '169463361',
    sidebar_fullscreen: '169463361',
    sidebar_bottom_fullscreen: '976222860',
    sticky_desktop: '976831407',
    sticky_mobile: '618031195',
    sticky_mobile_non_game_page: '618031195',
    universal_banner_1: '411815563',
    universal_banner_2: '411815563',
}

export const MEDIA_NET_MULTIFORMAT: HbBidderConfig = createMediaNetConfig({
    ...commonCRIDs,
    rewarded: '221260655',
    interstitial_preroll: '227546205',
    interstitial_midroll: '736161481',
    interstitial: '736161481',
})

export const MEDIA_NET_BANNER: HbBidderConfig = createMediaNetConfig({
    ...commonCRIDs,
    rewarded: '378355988',
    interstitial_preroll: '927178034',
    interstitial_midroll: '963468797',
    interstitial: '963468797',
})

export const MEDIA_NET_VIDEO: HbBidderConfig = createMediaNetConfig({
    ...commonCRIDs,
    rewarded: '427676774',
    interstitial_preroll: '683482584',
    interstitial_midroll: '881400384',
    interstitial: '881400384',
})
